export const GET_ALL_FAMILLE_REQUEST = "GET_ALL_FAMILLE_REQUEST";
export const GET_ALL_FAMILLE_SUCCESS = "GET_ALL_FAMILLE_SUCCESS";
export const GET_ALL_FAMILLE_FAIL = "GET_ALL_FAMILLE_FAIL";

export const ADD_FAMILLE_REQUEST = "ADD_FAMILLE_REQUEST";
export const ADD_FAMILLE_SUCCESS = "ADD_FAMILLE_SUCCESS";
export const ADD_FAMILLE_FAIL = "ADD_FAMILLE_FAIL";

export const UPDATE_FAMILLE_REQUEST = "UPDATE_FAMILLE_REQUEST";
export const UPDATE_FAMILLE_SUCCESS = "UPDATE_FAMILLE_SUCCESS";
export const UPDATE_FAMILLE_FAIL = "UPDATE_FAMILLE_FAIL";

export const DELETE_FAMILLE_REQUEST = "DELETE_FAMILLE_REQUEST";
export const DELETE_FAMILLE_SUCCESS = "DELETE_FAMILLE_SUCCESS";
export const DELETE_FAMILLE_FAIL = "DELETE_FAMILLE_FAIL";
